import { useEffect } from "react";
import { iAuth } from "../../../interfaces/auth";
import { getLocalValue } from "../../../utilities/localStore/calls";
import UserProfile from "../../UserProfile/index";

const AccessDenied = (props: any) => {
    useEffect(() => {
        (async () => {
            const crypto = getLocalValue<iAuth>("auth");

            switch (crypto?.theme) {
                case 1:
                    import("../styles/themes/om.scss");
                    break;
                default:
                    import("../styles/themes/default.scss");
                    break;
            }
        })();
    }, []);
    return (
        <div
            style={{ width: "100%", height: "100%" }}
            className="AccessDenied"
        >
            <UserProfile />
        </div>
    );
};

export default AccessDenied;
